import api, { ApiResponse } from './api';

import { MonitoringSystem } from 'entities/MonitoringSystem';

interface ListMonitoringSystemResponse {
  success: boolean;
  data: MonitoringSystem[];
}

export const getMonitoringSystemListService =
  (): ApiResponse<ListMonitoringSystemResponse> =>
    api({
      method: 'get',
      url: 'monitoring-systems',
      useToken: true,
    });
